<template>
  <form class="dropzone">
    <div id="dropzone-message" style="display: none;">
      <span class="dropzone-title">Drop files here or click to select</span>
    </div>
  </form>
</template>

<script>
import Dropzone from 'dropzone'
import '../../node_modules/dropzone/dist/dropzone.css'

Dropzone.autoDiscover = false

export default {
  name: 'dropzone',
  methods: {
    getSignedURL (file) {
      let endpoint = '/sign-upload-url'
      let payload = {
        filePath: this.$store.getters.user.id + '/' + file.name,
        contentType: file.type,
        bucketName: 'document-spaces'
      }

      return window.axios.post(endpoint, payload)
        .then(response => {
          return Promise.resolve(response.data.url || '/')
        })
        .catch(err => {
          return Promise.reject(err)
        })
    }
  },
  mounted () {
    const vm = this
    let options = {
      url: '/',
      method: 'put',
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },
      complete () {
        vm.$emit('fileUploadSuccess')
      },
      parallelUploads: 1,
      uploadMultiple: false,
      header: '',
      dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,
      autoProcessQueue: false,
      accept (file, done) {
        vm.getSignedURL(file)
          .then(url => {
            file.uploadURL = url
            done()
            setTimeout(() => vm.dropzone.processFile(file))
          })
          .catch(err => {
            done('Failed to get an S3 signed upload URL', err)
          })
      }
    }
    this.dropzone = new Dropzone(this.$el, options)
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })
  }
}
</script>
